import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import { useSearchParams } from "react-router-dom";
import { cmmsTheme } from "@setup/theme/cmms-theme";
import { useTaskListContext } from "../context/taskListContext";

// Work-order type filter. "A" (default) shows every type; PM / RM narrow the list.
const TYPE_OPTIONS = [
	{ value: "A", label: "All" },
	{ value: "PM", label: "PM" },
	{ value: "RM", label: "RM" },
];

export const TypeFilter = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const { actions } = useTaskListContext();
	const type = searchParams.get("type") ?? "A";

	const handleFilter = (e: any) => {
		const value = e.target.value;
		searchParams.set("type", value);
		setSearchParams(searchParams, { replace: true });
		actions.setTypeCode(value);
	};

	return (
		<Box position="relative">
			<TextField
				select
				label="Type"
				variant="outlined"
				margin="dense"
				value={type}
				onChange={handleFilter}
				fullWidth
				InputLabelProps={{
					style: {
						transform: "translate(14px, -6px) scale(0.75)",
						backgroundColor: cmmsTheme.colors.surfaceWhite,
						transition: "none !important",
						left: -3.5,
						padding: "0 5px",
					},
				}}
				InputProps={{ style: { color: "black" } }}>
				{TYPE_OPTIONS.map((opt) => (
					<MenuItem key={`type-${opt.value}`} value={opt.value}>
						{opt.label}
					</MenuItem>
				))}
			</TextField>
		</Box>
	);
};
